"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Formatsqr601aMembersXL = exports.sqr601aMembersXL = exports.Formatsqr601aXL = exports.sqr601aXL = void 0;
const Maybe_1 = require("../../lib/Maybe");
const Util_1 = require("../../lib/Util");
const ramda_1 = require("ramda");
const __1 = require("../..");
const getHFZExpire = (reqs) => ramda_1.pipe(Util_1.get('HFZRecord'), Maybe_1.Maybe.filter(({ IsPassed }) => IsPassed || reqs.CurrentCadetAchv.CadetAchvID < 4), Maybe_1.Maybe.map(({ DateTaken, IsPassed }) => [DateTaken.substr(0, 10), IsPassed]), Maybe_1.Maybe.map(([s, f]) => [+new Date(s) + 182 * 24 * 60 * 60 * 1000, f]), Maybe_1.Maybe.map(([s, f]) => new Date(s).toLocaleDateString('en-US') + (!f ? ' F' : '')), Maybe_1.Maybe.orSome(''))(reqs);
const unpoweredFlights = [1, 2, 3, 4, 5];
const poweredFlights = [6, 7, 8, 9, 10];
const oflightsShortDescription = (rides) => ([...new Set(rides.map(Util_1.get('Syllabus')))]
    .reduce(([powered, unpowered], syllabus) => poweredFlights.includes(syllabus)
    ? [powered + 1, unpowered]
    : unpoweredFlights.includes(syllabus)
        ? [powered, unpowered + 1]
        : [powered, unpowered], [0, 0])
    .join('p | ') + 'u')
    .replace('0p', '_p')
    .replace('0u', '_u');
const sqr601aXL = () => {
    let row = ['Event Manager Cadet Status Report SQR 60-1a'];
    const retVal = [];
    retVal.push(row);
    retVal.push(['This document was generated on: ', '', '', Date.now()]);
    retVal.push([]);
    retVal.push([]);
    row = ['Comments'];
    retVal.push(row);
    retVal.push([]);
    return retVal;
};
exports.sqr601aXL = sqr601aXL;
const Formatsqr601aXL = (sheet) => {
    const dateFormat = 'mm/dd/yyyy hh:mm';
    const dateWidth = dateFormat.length;
    sheet['!merges'] = [
        { s: { c: 0, r: 0 }, e: { c: 4, r: 0 } },
        { s: { c: 0, r: 1 }, e: { c: 2, r: 1 } },
        { s: { c: 1, r: 7 }, e: { c: 4, r: 7 } },
    ];
    sheet.D2.t = 'd';
    sheet.D2.z = dateFormat;
    sheet['!cols'] = [
        { width: 12 },
        { width: 12 },
        { wch: dateWidth },
        { wch: dateWidth },
        { width: 25 },
    ];
    sheet['!rows'] = [{ hpx: 19 }, { hpx: 17 }, {}, {}, {}];
    return sheet;
};
exports.Formatsqr601aXL = Formatsqr601aXL;
const sqr601aMembersXL = (nhqmembers, prospectiveMembers) => {
    var _a, _b, _c;
    let widths = [];
    let row = [
        'Current Grade',
        'GradeOrder',
        'Full Name',
        'CAPID',
        'Flight',
        'Exp',
        'Eligible or weeks',
        'Next Grade',
        'eSvc Achv',
        'LeadLab',
        'AeroEd',
        'SDA',
        'HFZ Cred Exp',
        'Drill Test',
        'Oath',
        'Char Dev or Wingman',
        'Mentor?',
        'GES',
        'O-Flights',
    ];
    const retVal = [];
    widths = [...row.map(item => item.toString().length)];
    retVal.push(row);
    const sortByMemberName = (a, b) => {
        const aMember = 'member' in a ? a.member : a;
        const bMember = 'member' in b ? b.member : b;
        return `${aMember.nameLast}, ${aMember.nameFirst}`.localeCompare(`${bMember.nameLast}, ${bMember.nameFirst}`);
    };
    const phase1Cadets = nhqmembers;
    const phase1CadetsDoc = [
        ...phase1Cadets,
        ...prospectiveMembers.filter(mem => mem.memberRank === 'CADET'),
    ]
        .sort(sortByMemberName)
        .map((mem) => ({
        requirements: 'requirements' in mem ? mem.requirements : null,
        member: 'member' in mem ? mem.member : mem,
    }));
    for (const loopmember of phase1CadetsDoc) {
        console.log(loopmember.requirements !== null
            ? getHFZExpire(loopmember.requirements)
            : 'reqs = null', loopmember.requirements);
        row = [
            loopmember.member.memberRank,
            ((_a = loopmember.requirements) === null || _a === void 0 ? void 0 : _a.CurrentCadetAchv.CadetAchvID.toString())
                ? (_b = loopmember.requirements) === null || _b === void 0 ? void 0 : _b.CurrentCadetAchv.CadetAchvID.toString()
                : '',
            `${loopmember.member.memberRank} ${loopmember.member.nameLast}, ${loopmember.member.nameFirst}`,
            loopmember.member.id.toString(),
            loopmember.member.flight !== null ? loopmember.member.flight : '',
            loopmember.member.type === 'CAPNHQMember'
                ? new Date(loopmember.member.expirationDate + 60 * 60 * 24).getTime() -
                    new Date().getTime() <=
                    0
                    ? 'Y'
                    : new Date(loopmember.member.expirationDate + 60 * 60 * 24).getTime() -
                        new Date().getTime() <=
                        60 * 60 * 24 * 30 * 1000
                        ? '<'
                        : ''
                : '',
            loopmember.requirements !== null
                ? Maybe_1.Maybe.isSome((_c = loopmember.requirements) === null || _c === void 0 ? void 0 : _c.LastAprvDate)
                    ? loopmember.requirements.LastAprvDate.value -
                        new Date('01/01/2010').getTime() >
                        0
                        ? new Date(loopmember.requirements.LastAprvDate.value +
                            60 * 60 * 24 * 56 * 1000).toLocaleDateString('en-US')
                        : Math.round(Math.round(new Date().getTime() -
                            (loopmember.member.type === 'CAPNHQMember'
                                ? new Date(loopmember.member.joined).getTime()
                                : 0)) /
                            (1000 * 60 * 60 * 24 * 7))
                    : Math.round(Math.round(new Date().getTime() -
                        (loopmember.member.type === 'CAPNHQMember'
                            ? new Date(loopmember.member.joined).getTime()
                            : 0)) /
                        (1000 * 60 * 60 * 24 * 7))
                : '',
            loopmember.requirements !== null
                ? __1.CadetPromotionRequirementsMap[loopmember.requirements.NextCadetGradeID].Grade
                : '',
            loopmember.requirements !== null
                ? loopmember.requirements.CurrentCadetAchv.CadetAchvID.toString() +
                    '-' +
                    loopmember.requirements.MaxAprvStatus.substr(0, 1)
                : '',
            loopmember.requirements !== null
                ? loopmember.requirements.MaxAprvStatus === 'APR'
                    ? __1.CadetPromotionRequirementsMap[loopmember.requirements.NextCadetAchvID]
                        .Leadership === 'None'
                        ? 'N/A'
                        : ''
                    :
                        new Date(loopmember.requirements.CurrentCadetAchv.LeadLabDateP).getTime() -
                            new Date('01/01/2010').getTime() <=
                            0
                            ? __1.CadetPromotionRequirementsMap[loopmember.requirements.NextCadetAchvID]
                                .Leadership === 'None'
                                ? 'N/A'
                                : ''
                            : new Date(loopmember.requirements.CurrentCadetAchv.LeadLabDateP.replace(/-/g, '/').replace(/T.+/, '')).toLocaleDateString('en-US')
                : '',
            loopmember.requirements !== null
                ? loopmember.requirements.MaxAprvStatus === 'APR'
                    ? __1.CadetPromotionRequirementsMap[loopmember.requirements.NextCadetAchvID]
                        .Aerospace === 'None'
                        ? 'N/A'
                        : ''
                    :
                        new Date(loopmember.requirements.CurrentCadetAchv.AEDateP).getTime() -
                            new Date('01/01/2010').getTime() <=
                            0
                            ? __1.CadetPromotionRequirementsMap[loopmember.requirements.NextCadetAchvID]
                                .Aerospace === 'None'
                                ? 'N/A'
                                : ''
                            : new Date(loopmember.requirements.CurrentCadetAchv.AEDateP.replace(/-/g, '/').replace(/T.+/, '')).toLocaleDateString('en-US')
                : '',
            loopmember.requirements !== null
                ? loopmember.requirements.MaxAprvStatus === 'APR'
                    ? __1.CadetPromotionRequirementsMap[loopmember.requirements.NextCadetAchvID]
                        .SDAPresentation === false &&
                        __1.CadetPromotionRequirementsMap[loopmember.requirements.NextCadetAchvID]
                            .SDAService === false &&
                        __1.CadetPromotionRequirementsMap[loopmember.requirements.NextCadetAchvID]
                            .SDAWriting === false
                        ? 'N/A'
                        : ''
                    :
                        __1.CadetPromotionRequirementsMap[loopmember.requirements.NextCadetAchvID]
                            .SDAPresentation === false &&
                            __1.CadetPromotionRequirementsMap[loopmember.requirements.NextCadetAchvID]
                                .SDAService === false &&
                            __1.CadetPromotionRequirementsMap[loopmember.requirements.NextCadetAchvID]
                                .SDAWriting === false
                            ? 'N/A'
                            : 'Undef'
                : '',
            loopmember.requirements !== null ? getHFZExpire(loopmember.requirements) : '',
            loopmember.requirements !== null
                ? loopmember.requirements.MaxAprvStatus === 'APR'
                    ? __1.CadetPromotionRequirementsMap[loopmember.requirements.NextCadetAchvID]
                        .Drill === 'None'
                        ? 'N/A'
                        : __1.CadetPromotionRequirementsMap[loopmember.requirements.NextCadetAchvID]
                            .Drill
                    :
                        new Date(loopmember.requirements.CurrentCadetAchv.DrillDate).getTime() -
                            new Date('01/01/2010').getTime() <=
                            0
                            ? __1.CadetPromotionRequirementsMap[loopmember.requirements.NextCadetAchvID]
                                .Drill === 'None'
                                ? 'N/A'
                                : __1.CadetPromotionRequirementsMap[loopmember.requirements.NextCadetAchvID]
                                    .Drill
                            : new Date(loopmember.requirements.CurrentCadetAchv.DrillDate.replace(/-/g, '/').replace(/T.+/, '')).toLocaleDateString('en-US')
                : '',
            loopmember.requirements !== null
                ? loopmember.requirements.CurrentCadetAchv.CadetOath
                    ? 'Y'
                    : ''
                : '',
            loopmember.requirements !== null
                ? loopmember.requirements.MaxAprvStatus === 'APR'
                    ? __1.CadetPromotionRequirementsMap[loopmember.requirements.NextCadetAchvID]
                        .CharDev === false
                        ? 'N/A'
                        : ''
                    :
                        new Date(loopmember.requirements.CurrentCadetAchv.MoralLDateP).getTime() -
                            new Date('01/01/2010').getTime() <=
                            0
                            ? __1.CadetPromotionRequirementsMap[loopmember.requirements.NextCadetAchvID]
                                .CharDev === false
                                ? 'N/A'
                                : ''
                            : new Date(loopmember.requirements.CurrentCadetAchv.MoralLDateP.replace(/-/g, '/').replace(/T.+/, '')).toLocaleDateString('en-US')
                : '',
            loopmember.requirements !== null
                ? __1.CadetPromotionRequirementsMap[loopmember.requirements.NextCadetAchvID].Mentor
                    ? loopmember.requirements.CurrentCadetAchv.OtherReq
                        ? 'Y'
                        : ''
                    : 'N/A'
                : '',
            loopmember.requirements !== null
                ? Maybe_1.Maybe.isSome(loopmember.requirements.ges)
                    ? 'Y'
                    : ''
                : '',
            loopmember.requirements !== null
                ? oflightsShortDescription(loopmember.requirements.oflights)
                : '',
        ];
        retVal.push(row);
    }
    return [retVal, widths.map(width => width + 3)];
};
exports.sqr601aMembersXL = sqr601aMembersXL;
const Formatsqr601aMembersXL = (sheet, columnMaxWidths, numRows) => {
    const dateFormat = 'yyyy-mm-dd';
    const dateWidth = dateFormat.length + 1;
    const rowHeight = 22;
    sheet['!rows'] = [{ hpt: rowHeight }];
    let j = 2;
    while (j <= numRows) {
        j += 1;
    }
    sheet['!cols'] = columnMaxWidths.map(wch => ({ wch }));
    sheet['!cols'] = [
        { width: 10 },
        { width: 8 },
        { width: 32 },
        { width: 8 },
        { width: 8 },
        { width: 6 },
        { wch: dateWidth },
        { width: 10 },
        { width: 8 },
        { wch: dateWidth },
        { wch: dateWidth },
        { wch: dateWidth },
        { wch: dateWidth },
        { wch: dateWidth },
        { width: 8 },
        { wch: dateWidth },
        { width: 10 },
        { width: 8 },
        { width: 12 },
    ];
    return sheet;
};
exports.Formatsqr601aMembersXL = Formatsqr601aMembersXL;
//# sourceMappingURL=sqr601a.js.map